import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { PersonaCheckboxDisplayOption } from "../store/schema/PersonaCheckboxDisplayOption";
import getPersonaCheckboxDisplay from "../store/selectors/getPersonaCheckboxDisplay";

/**
 * Returns whether the message list checkboxes should always be shown (regardless
 * of hover, selection, or select-all state).
 *
 * This is the case when the ML checkbox behavior flight is enabled and the user
 * selected the "checkbox only" leading element (no sender image, checkbox always
 * visible).
 */
export default function shouldAlwaysShowMessageListCheckboxes(): boolean {
    return (isGlobalFeatureEnabled("tri-mlCheckboxBehavior") &&
        getPersonaCheckboxDisplay() === PersonaCheckboxDisplayOption.ShowCheckboxOnly);
}
